import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { timeout } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class UploadService {
  constructor(
    private http: HttpClient,
    private authService: AuthService
  ) {}

  uploadLogoProject(projectId: string, fieldName: string, formData: FormData) {
    return this.http.post<any>(`${environment.apiUrl}/upload/UploadLogo?projectId=${projectId}&fieldName=${fieldName}`, formData, { headers: this.authService.headers, reportProgress: true, observe: 'events' });
  }

  uploadProof(id: string, formData: FormData) {
    return this.http.post<any>(`${environment.apiUrl}/upload/UploadProof?id=${id}`, formData, { headers: this.authService.headers, reportProgress: true, observe: 'events' });
  }

  uploadCalculCeu(id: string, formData: FormData) {
    return this.http.post<any>(`${environment.apiUrl}/upload/UploadCalculCeu?id=${id}`, formData, {
      headers: this.authService.headers,
      reportProgress: true,
      observe: 'events'
    });
  }

  uploadWorkInspectionProof(proofId: string, formData: FormData) {
    return this.http
      .post<any>(`${environment.apiUrl}/upload/UploadWorkInspectionProof/${proofId}`, formData, {
        headers: this.authService.headers,
        reportProgress: true,
        observe: 'events'
      })
      .pipe(timeout(60000));
  }

  uploadDredgeProof(matCompoId: string, formData: FormData) {
    return this.http.post<any>(`${environment.apiUrl}/upload/UploadDredgeProof/${matCompoId}`, formData, {
      headers: this.authService.headers,
      reportProgress: true,
      observe: 'events'
    });
  }

  uploadTunnelingProof(matCompoId: string, formData: FormData) {
    return this.http.post<any>(`${environment.apiUrl}/upload/UploadTunnelerProof/${matCompoId}`, formData, {
      headers: this.authService.headers,
      reportProgress: true,
      observe: 'events'
    });
  }
}
